import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { ICase } from "@/models/case/case.type"
import { CaseParser } from "@/models/case/case.parser"
import { GetCasesByCoreIdQuery } from "@/api/hasura/generated/graphql"

export interface ICasesService {
  getCasesForAccount(coreId: number | null): QueryResult<ICase[]>
}

class CasesServiceClass implements ICasesService {
  getCasesForAccount(coreId: number | null): QueryResult<ICase[]> {
    return useQuery({
      ...HasuraQueries.account.cases(coreId ?? -1),
      placeholderData: [],
      parserFn: (raw: GetCasesByCoreIdQuery) => {
        return raw.cases.map((c) => CaseParser.toDomain(c))
      },
      useRawResponse: true,
      enabled: !!coreId,
    })
  }
}

export const CasesService = new CasesServiceClass()
